import { render, staticRenderFns } from "./AdjustSetting.vue?vue&type=template&id=6ac1b49b&scoped=true"
import script from "./AdjustSetting.vue?vue&type=script&lang=js"
export * from "./AdjustSetting.vue?vue&type=script&lang=js"
import style0 from "./AdjustSetting.vue?vue&type=style&index=0&id=6ac1b49b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac1b49b",
  null
  
)

export default component.exports